import CompanyRoutes from "../../apiRoutes/CompanyRoutes";
import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";

export async function requestHelp(payload) {
    // 1. Limpieza final de datos condicionales
    const cleanPayload = {
        ...payload,
        
        // Si no es para un tercero, forzamos el detalle a null
        third_party_details: payload.is_third_party ? payload.third_party_details : null,
        
        // Si no seleccionó "Medicamentos", limpiamos el detalle médico
        medical_details: payload.required_items.includes("Medicamentos") 
            ? payload.medical_details 
            : null,
    };

    // 2. Enviamos el cleanPayload directamente (SIN envolver en llaves adicionales)
    const response = await api.post(publicRoutes.HELP.REQUEST, cleanPayload);
    
    return response;
}

export async function getTransparencyData()
{
    const response = await api.get(publicRoutes.HELP.TRANSPARENCY);
    return response;
}


export async function getHelpRequests(filters = {}) {
    const cleanFilters = { ...filters };

    // Limpiamos los filtros antes de enviarlos
    if (cleanFilters.city === "all" || !cleanFilters.city) delete cleanFilters.city;
    if (!cleanFilters.search || cleanFilters.search === "") delete cleanFilters.search;
    if (!cleanFilters.status) delete cleanFilters.status;

    // Convertimos el objeto a una cadena de consulta (query string)
    // Ej: ?status=pending&city=Puerto+La+Cruz
    const queryString = new URLSearchParams(cleanFilters).toString();
    
    // Construimos la URL final
    const finalUrl = queryString ? `${CompanyRoutes.HELP.REQUESTS}?${queryString}` : CompanyRoutes.HELP.REQUESTS;

    console.log("URL final enviada a Laravel:", finalUrl);
    const response = await api.get(finalUrl);
    return response;
}

export async function updateRequestStatus(id, payload) {
    const response = await api.post(`${CompanyRoutes.HELP.REQUESTS}/${id}/status`, payload);
    return response;
}